<template>
    <div class="py-10 px-10 lg:px-20 xl:px-32 flex flex-row flex-wrap justify-center xl:justify-between items-center"
         id="contact">
        <div
            class="w-full md:w-3/4 tablet:w-8/12 lg:w-3/6 xl:w-2/6 flex flex-col items-center md:flex-row md:items-start justify-between pb-10 xl:pb-0">
            <div class="" id="who1">
                <h1 class="text-2xl text-heading md:text-4xl font-bold text-center md:text-left pb-8 uppercase">
                    {{ tr('contact.contact.title') }}
                </h1>
                <p class="text-text text-left py-1">
                    <img alt="phone"
                         class="inline pr-3"
                         src="../assets/img/icons/call_icon.svg"
                    >
                    <a href="tel:+421948030073">
                        +421 948 030 073
                    </a>
                </p>
                <p class="text-text text-left py-1">
                    <img alt="email"
                         class="inline pr-3"
                         src="../assets/img/icons/email_icon.svg"
                    >
                    <a href="mailto:pareli@pareli.sk">
                        pareli@pareli.sk
                    </a>
                </p>
                <p class="text-text text-left py-1">
                    <img alt="linkedin"
                         class="inline pr-3"
                         src="../assets/img/icons/linkedin_icon.svg"
                    >
                    <a href="https://www.linkedin.com/company/pareli/" target="_blank">
                      PaReLi s.r.o.
                    </a>
                </p>
            </div>

            <div class="" id="who2">
                <h1 class="text-2xl text-heading md:text-4xl font-bold text-center md:text-left pb-8 uppercase pt-10 md:pt-0">
                    {{ tr('contact.address.title') }}
                </h1>

                <div class="flex items-start justify-center md:justify-start">
                    <img alt="phone" class="inline pr-3" src="../assets/img/icons/place_icon.svg">
                    <div class="">
                        <p class="text-text text-left pb-1">
                            Office Bratislava
                        </p>
                        <p class="text-text text-left py-1">
                            Haydnova ul. 20/C
                        </p>
                        <p class="text-text text-left py-1">
                            811 02 Bratislava – Staré Mesto
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div id="map" class="w-full md:w-3/4 tablet:w-3/5 lg:w-2/5 pt-16 lg:pt-0"> -->
        <div class="" id="map">
            <Map/>
            <!-- <img class="object-contain shadow-lg" src="../assets/img/general/map.png" alt=""> -->
        </div>
    </div>
</template>

<script>
import {Translatable} from '@/data/translations';
import Map from './Map.vue';

export default {
    name: 'Contact',
    mixins: [Translatable],
    components: {Map},
};
</script>

<style>
#map {
    height: 400px;
    width: 640px;
}

@media (max-width: 640px) {
    #map {
        height: 350px;
        width: 100%;
    }
}

@media (max-width: 450px) {
    #map {
        height: 250px;
        width: 100%;
    }
}
</style>
